import { useEffect, useState } from "react";
import { onValue, ref, remove, set } from "firebase/database";

import HistoryTable from "../components/results-table/HistoryTable";
import ResultForm from "../components/game-form/GameForm";
import { database } from "../firebase";
import { ROTATION } from "../constants";
import { useUser } from "../contexts/UserContext";
import { useSnack } from "../contexts/AlertContext";

const RecordPage = () => {
  const user = useUser();
  const setSnack = useSnack();

  const [gameLog, setGameLog] = useState([]);
  const [results, setResults] = useState([]);
  const [wins, setWins] = useState(0);
  const [losses, setLosses] = useState(0);
  const [format, setFormat] = useState(ROTATION);

  const handleSubmit = async (game) => {
    const timestamp = Date.now();
    game.id = timestamp;

    const gamesRef = ref(database, `id/${user.uid}/games/${game.id}`);
    try {
      await set(gamesRef, game);
      setSnack({
        open: true,
        message: "Successfully recorded game!",
        type: "success"
      });
    } catch (e) {
      setSnack({
        open: true,
        message: "An error occured saving your game.",
        type: "error"
      });
    }
  };

  const handleFormatChange = (formatValue) => {
    setFormat(formatValue);
  };

  const handleDelete = async (id) => {
    const dbRef = ref(database, `id/${user.uid}/games/${id}`);
    try {
      await remove(dbRef);
      setSnack({ open: true, message: "Deleted Game!", type: "success" });
    } catch (e) {
      setSnack({
        open: true,
        message: "An error occured deleting your game",
        type: "error"
      });
    }
  };

  const fetchGames = async () => {
    const dbRef = ref(database, `id/${user.uid}/games`);
    onValue(dbRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        setGameLog(Object.values(data));
      } else {
        setGameLog([]);
      }
    });
  };

  useEffect(() => {
    if (user) fetchGames();
  }, [user]);

  useEffect(() => {
    if (gameLog.length === 0) return;

    const formatResults = gameLog.filter((game) => game.format === format);
    const winCount = formatResults.filter(
      (game) => game.result === "WIN"
    ).length;
    const lossCount = formatResults.filter(
      (game) => game.result === "LOSE"
    ).length;

    setResults(formatResults);
    setWins(winCount);
    setLosses(lossCount);
  }, [gameLog, format]);

  return (
    <>
      <ResultForm
        format={format}
        onSubmit={handleSubmit}
        onFormatChange={handleFormatChange}
      />
      <HistoryTable
        results={results}
        wins={wins}
        losses={losses}
        onDelete={handleDelete}
      />
    </>
  );
};

export default RecordPage;
